<!--课程名称、课时 、价格-->
<template>
  <div>
    <CourseName
      :courseName="courseBaseData.name"
      :brief="courseBaseData.brief"
    ></CourseName>
    <CoursePeriod :courseBaseData="courseBaseData"></CoursePeriod>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CourseName from './CourseName.vue';
import CoursePeriod from './CoursePeriod.vue';

export default {
  components: {
    CourseName,
    CoursePeriod,
  },
  computed: {
    ...mapState(['courseBaseData']),
  },
};
</script>
